const HelpModalItemsList = [
  {
    id: 0,
    ttl: '築年数',
    txt:
      '<p>ご自身の物件の築年数を選択してください。合致するものがない場合、繰り上げた築年数を選択してください。</p><p>例：11年→15年</p><p>実際の保険料試算については、各保険会社のサイトで詳細をご確認ください。</p>'
  },
  {
    id: 1,
    ttl: '建物保険金額',
    txt:
      '<p>火災などの災害で、建物に損害が発生した場合に、保険会社が支払う保険金の限度額です。マンションの場合、購入金額の30～40％程度（1000万円前後）が一般的です。</p>'
  },
  {
    id: 2,
    ttl: '家財保険金額',
    txt:
      '<p>火災などの災害で、家財に損害が発生した場合に、保険会社が支払う保険金の限度額です。<br/>家財の保険金額は、再調達価額が目安になります。再調達価額とは、損害にあった家財と同等のものを再購入する場合に必要な金額のことをいいます。</p><p>さらに詳しく知りたい方は<a href="/cont/kazai/" target="_blank">こちら</a></p>'
  },
  {
    id: 3,
    ttl: '地震保険',
    txt:
      '<p>地震保険は、地震や噴火、津波による損害を補償するものです。<br/>火災保険だけでは、地震等による損害は補償されません。また、地震保険は、火災保険とセットでのみ加入できる保険です。</p><p>地震保険で補償する損害例）<br/>・地震が原因の火災<br/>・火山の噴火が原因の火災<br/>・地震が原因の津波による住居の損害</p><p>また地震保険には、建物の免震・耐震性能に応じた割引制度があります。<br/>1981年（昭和56年）6月1日以降に新築された建物には建築年割引が適用されます。耐震等級などが適用できる場合は、地震保険料がさらに割引になる可能性がありますので、各保険会社サイトにて詳細をご確認ください。<br/>※建物の免震、耐震性能に応じた割引は、重複して受けることはできません。</p>'
  },
  {
    id: 4,
    ttl: '地震保険・耐震構造（等級）',
    txt:
      '<p>地震保険は、地震や噴火、津波による損害を補償するものです。<br/>火災保険だけでは、地震等による損害は補償されません。また、地震保険は、火災保険とセットでのみ加入できる保険です。</p><p>地震保険で補償する損害例）<br/>・地震が原因の火災<br/>・火山の噴火が原因の火災<br/>・地震が原因の津波による住居の損害</p><p>また地震保険には、建物の免震・耐震性能に応じた割引制度があります。<br/>1981年（昭和56年）6月1日以降に新築された建物には建築年割引が適用されます。耐震等級などが適用できる場合は、地震保険料がさらに割引になる可能性がありますので、各保険会社サイトにて詳細をご確認ください。<br/>※建物の免震、耐震性能に応じた割引は、重複して受けることはできません。</p>'
  },
  {
    id: 5,
    ttl: '住宅ローン',
    txt:
      '<p>ご自身の住宅ローンのご利用状況を選択してください。<br/>住宅ローンのご利用状況によって、契約可能となる商品が変わる場合がございます。</p>'
  },
  {
    id: 6,
    ttl: '破損・汚損',
    txt:
      '<p>不測かつ偶発的に発生する事故によって建物や家財が損傷を受けた場合の補償のことです。</p><p>■対象外の損傷<br/>・すり傷や塗料のはがれ落ちといった単なる外見上の損傷や汚損<br/>・自然的な消耗や劣化</p>'
  },
  {
    id: 7,
    ttl: '水災',
    txt:
      '<p>台風や暴風雨、大雨によって被害が発生した場合に補償されるものです。<br>なお、水災の被害が一定規模より下回る場合、保険金が支払われないケースもあります。保険会社の補償範囲を確認しましょう。</p><p>■対象となる例<br/>・台風などによる床上浸水、地盤面より45㎝を超える浸水、または損害割合が30％以上の場合<br/>・高潮などによって流れ出た海水や漂流物による住宅の破損<br/>・大雨による土砂崩れで住居が埋没する</p><p>■対象外となる例<br/>・地震や噴火を原因とする津波や土砂崩れ<br/>・雹や雪による被害</p>'
  },
  {
    id: 8,
    ttl: '火災、落雷、破裂、爆発',
    txt:
      '<p>火災保険の基本となる補償です。</p><p>■対象となる例<br/>・過失による火災、もらい火、放火<br/>・落雷による火災、建物の損傷<br/>・ガス漏れなどによる破裂・爆発</p>'
  },
  {
    id: 9,
    ttl: '風災、ひょう災、雪災',
    txt:
      '<p>台風、竜巻、暴風などの強い風、雹（ひょう）、豪雪、雪崩など自然災害による損害を補償します。</p><p>建物の補償例）<br/>※建物が保険の対象に含まれる場合。<br/>・強風や暴風によって、屋根瓦が飛ばされたり、窓ガラスが破損した。</p><p>家財の補償例）<br/>※家財が保険の対象に含まれる場合。<br/>・台⾵で割れた窓ガラスから水が漏れ、家具が壊れた。</p>'
  },
  {
    id: 10,
    ttl: '盗難、物体飛来、水ぬれ、騒じょう',
    txt:
      '<p>建物外部からの物体の飛来、漏水、集団による破壊行動、盗難行為による損害を補償します。</p><p>建物の補償例）<br/>※建物が保険の対象に含まれる場合。<br/>・自動車が自宅の壁に衝突して壊れた。<br/>・空き巣が侵入した際に、窓ガラスを割られた。</p><p>家財の補償例）<br/>※家財が保険の対象に含まれる場合。<br/>・空き巣が侵入しテレビを盗まれた。<br/>・キッチンやトイレ等の給水管が破裂して水浸しになり、家具が損傷した。</p>'
  },
  {
    id: 11,
    ttl: '地震、噴火、津波による倒壊、火災',
    txt:
      '<p>地震・噴火・津波によって、建物や家財が被害を受けた際に補償します。火災保険では補償されません。</p><p>さらに詳しく知りたい方は<a href="/cont/jishin-basic/" target="_blank">こちら</a></p>'
  },
  {
    id: 12,
    ttl: '事故時諸費用',
    txt:
      '<p>火災等が発生して損害を受けた際に、臨時の諸費用（当面の生活必需品の購入など）を補償します。</p><p class="helpModal-txt-memo">※損害保険金が支払われる場合に限ります。</p><p class="helpModal-txt-memo">※保険商品によって、支払い割合や限度額が異なります。</p>'
  },
  {
    id: 13,
    ttl: '特別費用',
    txt:
      '<p>建物の損害に対する損害保険金の支払額が、1回の事故で建物保険金額に相当する額となり、保険契約が終了する場合に支払われます。</p><p class="helpModal-txt-memo">※保険商品によって、支払い割合や限度額が異なります。</p>'
  },
  {
    id: 14,
    ttl: '地震火災費用',
    txt:
      '<p>地震・噴火、これらによる津波を原因とする火災で、一定以上の損害を受けたときに支払われます。</p><p class="helpModal-txt-memo">※保険商品によって、支払い割合や限度額が異なります。</p>'
  },
  {
    id: 15,
    ttl: '建物構造',
    txt:
      '<p>建物構造（柱の種類）によって保険料が変わります。構造級別を選択してください。</p><p>Ｍ構造<br/>下記の『共同住宅』<br/>コンクリート造建物、コンクリートブロック造建物、れんが造建物、石造建物、耐火建築物の共同住宅建物</p><p>Ｔ構造<br/>下記のいずれかに該当する建物<br/>コンクリート造建物、コンクリートブロック造建物、レンガ造建物、石造建物、鉄骨造建物、耐火建築物、準耐火建築物、省令準耐火建築物</p><p>Ｈ構造<br/>Ｍ構造およびT構造に該当しない建物</p>'
  }
]

export default HelpModalItemsList
